export const luxoriaConfig = {
  // 按页面语言选商店地区（中文页 /cn、英文页 /us）：不带地区码的链接在 Mac 网页版会被苹果跳到 Today 页。
  appStoreUrl: {
    en: "https://apps.apple.com/us/app/id6771683268",
    zh: "https://apps.apple.com/cn/app/id6771683268"
  },
  contactEmail: "axqora@gmail.com"
} as const;
